<template>
    <div
        class="row row-sm"
        :style="`
            justify-content: ${justifyContent};
            width: 100%; 
            margin-left: 0;
        `">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'RowCardConfig',
    props: {
        data: { default:Object }
    },
    data() {
        return {
            settings: this.data,
            justifyContent: this.data.card_config?.justify_content ?? 'space-between'
        }
    }
}
</script>